// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../assets/icons/play-control.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.new-post-modal .modal2__container {
    width: 780px;
}
.new-post__header {
    display: flex;
    align-items: center;        
    background: var(--white-color);
    align-self: flex-start;
    padding-top: var(--space);
}
.new-post__header .MuiList-padding, .new-post__header .MuiListItem-gutters{
    padding: 0;
}
.new-post__header span.icon-chevron-down {
    font-size: calc(var(--space) + var(--space-quarter));
    margin-left: var(--space-half);
}
p.new-post__header__title {
    margin-right: var(--space);
    color: var(--primary-dark-color) !important;
}
.new-post__header__button {
    margin-right: var(--space);
    display: flex;
    align-items: center;
    cursor: pointer;
}
.new-post__header__button.baloa-names{
    color: var(--basic-gray-color);
}
.new-post__content {
    overflow-y: scroll;
    max-height: 550px;
    position: relative;
    /* height: 300px; */
    min-height: 0px;
    margin-top: var(--space);

}
 .new-post__content__progress{
    margin: var(--space-half-quarter) 0 var(--space) 0;
}

.new-post__content__progress progress.new-post__content__progress__element {
	display:flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: calc( var(--space) + var(--space-eighth) );
}

.new-post__content__progress progress.new-post__content__progress__element::-webkit-progress-bar {
	height: calc( var(--space) + var(--space-eighth) );
	background-color: var(--body-background-color);
}

.new-post__content__progress progress.new-post__content__progress__element::-webkit-progress-value {
	height:calc( var(--space) + var(--space-eighth) );
	background: var(--new-green-color);   
    opacity: 1;
}

.new-post__content__progress__element:after {
	margin: 0;
	padding:0;
	position: absolute;
    font-size: var(--space-half-quarter);
    font-family: var(--secondary-font);
    font-weight: var(--font-medium);
    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );
    color: var(--primary-very-dark-color);
}

.new-post__content__media {
    position: relative;
    height: 400px;
    width: 100%;
}
.new-post__content__media img {
    height: 100%;
}
.new-post__content__media__video-control {
    width: 100%;
    height: 250px;
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    justify-content: center;
    align-items: center;
}
.new-post__content__media__video {
    width: 100%;
    height: 250px;
}
.new-post__content__media__video-control__icon {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    background-repeat: no-repeat;
    width: var(--space-x3);
    height:var(--space-x3);
    background-size: contain;
}
.new-post__content__media__control-mute {
    position: absolute;
    right: 25%;
    top: 50%;
}
.new-post__content__media__control-mute__icon {
    color: var(--new-green-color);
    font-size: var(--space-x2);
}
.new-post__content__result {
    position: relative;



    height: 400px;
    width: 100%;
    display: flex;
    justify-content: center;
}
.new-post__content__result__container {
    position: relative;
    height: 100%;
}
.new-post__content__result__container__remove {
    position: absolute;
    right: var(--space);
    top: var(--space);
}

.new-post__content__result__container__remove__revert {
    position: absolute;
    right: var(--space);
    top: var(--space);
    z-index: 999;
}

.new-post__content__result img {
    height: 100%;
}

.new-post__form {
    background: var(--white-color);
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 var(--space-and-half);
}
.new-post__form input {
    width: 100%;
}
.new-post__form__form {
    display: flex;
    flex-direction: column;
}
.input-field.new-post__form__field {
    margin: 0;
    margin-top: var(--space-and-half);
}
.new-post__form__field input {
    margin: 0;
}
.new-post__form__group {
    display: flex;
    justify-content: space-between;
    padding: var(--space) 0;
}
.new-post__form__submit {
    align-self: flex-end;
    margin-left: var(--space);
}
.MuiAvatar-root.new-post__list-item__avatar{
    width: 40px;
    height: 40px;
}

.new-post__list-item__text .MuiTypography-body1{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-medium);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    color: var(--primary-dark-color);
    padding-left: var(--space-half);
}

.new-post__list-item.icon-ball{
    font-size: 30px;
    font-weight: var(--font-bold);
    border-radius: 50%;
    padding: 5px;
    height: 40px;
    color: var(--white-color);
}

.new-post__form__field .input-field-multiline-input{
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: var(--font-regular);
    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */
    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */
    letter-spacing: 0.0025em;
    color: var(--primary-very-dark-color);
    border: none;
    padding: 0;
    background-color: transparent;
}

.new-post__form__field .input-field-multiline-input:focus { 
    outline: none; 
}

.new-post__header__button .icon-image-70 {
    font-size: var(--space-x2);
    color: #64B5F6;
    margin-right: 4px;
}
.new-post__header__button .icon2-video-offer {
    font-size: var(--space-x2);
    color: #F77B73;
    margin-right: 4px;
}
.new-post__header__button .icon-field {
    font-size: var(--space-x2);
    color: #6ECB96;
    margin-right: 4px;
}
.new-post__header__buttons{
    display: flex;
    align-items: center;
}

.create-post-modal__show-formation {
    height: 42vh;
}


.create-post-modal__aspect-ratio {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 160px;
    background: rgba(42, 48, 42, 0.6);
    padding: calc( var(--space-half) - var(--space-eighth) );
    
}

.create-post-modal__aspect-ratio .baloa-table-column {
    color: var(--white-color);
    font-size: var(--space-half-quarter);
    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );
}

.create-post-modal__aspect-ratio > div:not(:first-of-type) { 
    border: 1px solid var(--white-color);
    border-radius: var(--space-eighth);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: var(--space-half-quarter);
    text-align: center;    
}

.create-post-modal__aspect-ratio__horizontal {
    width: var(--space-x2 );
    height: var(--space-and-half );
    background: #D9D9D9;
    color: var(--primary-very-dark-color);
}

.create-post-modal__aspect-ratio__square {
    width: var(--space-and-half );
    height: var(--space-and-half );
    background: #D9D9D9;
    color: var(--primary-very-dark-color);    
}

.create-post-modal__aspect-ratio__vertical {
    width: var(--space-and-half );
    height: var(--space-x2 );
    background: #D9D9D9;
    color: var(--primary-very-dark-color); 
}

.create-post-modal__aspect-ratio .active {
    background: transparent;
    color: var( --white-color );
}

#lock-menu .MuiMenu-paper{
    max-height: calc(100vh - 96px);
}

.new-post__content__media__video-add-options {
    border: 1px solid var(--new-gray-background-color);
    border-radius: 8px;
}

.new-post__content__media__video-add-options__option {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 14px;
    border-top: 1px solid var(--new-gray-background-color);
}

.new-post__content__media__video-add-options__option:first-child {
    border-top: none;
}

.new-post__content__media__video-add-options__option-text {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
}

.new-post__content__media__video-add-options__option-text .baloa-names {
    color: var(--primary-very-dark-color);
}

.new-post__content__media__video-add-options__option-text .hubicon-video_library1::before {
    font-size: 20px;
    color: #0D6EFD;
}

.new-post__content__media__video-add-options__option-text .hubicon-video_camera_front1::before {
    font-size: 20px;
    color: #FD9843;
}

.new-post__form__form .input-field-multiline {
    margin-top: var(--space-and-half);
    margin-bottom: 0;
}

.new-post__footer {
    display: flex;
    align-items: center;        
    background: var(--white-color);
    align-self: flex-start;
    padding-top: var(--space);
}

@media screen and ( max-width: 375px ) {

    .input-field-multiline.new-post__form__field{
        margin: 0;
    }
    .new-post__content__media {
        height: 250px;
    }
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .new-post-modal .modal2__container {
        margin: 0;
        width: 100%;
        border-radius: 0;
        height: 100%;
        max-height: unset;
    }

    .new-post-modal .modal2__header {
        border-bottom: 1px solid var(--new-input-background-color);
        padding-bottom: var(--space);
    }

    .new-post-modal .modal2__content { 
        height: 100%;
    }

    .new-post__form {
        padding: 0;
    }

    .new-post__content {
        max-height: unset;
        height: calc(100vh - 300px);
    }

    .new-post__content__media__video {
        max-height: calc(100vh - 520px);
        height: unset;
    }

    .new-post__content__media {
        /* height: calc(100vh - 480px); */
        height: unset;
    }

    .new-post__content__media__video-add-options__option {
        padding: 14px 10px;
    }

    .new-post__content__media__video-add-options {
        margin: 12px;
    }

    .new-post__form__group {
        flex-direction: column;
        align-items: center;
        padding-bottom: 0;
        position: absolute;
        bottom: 0;
        width: 100%;
    }

    .new-post__header {
        padding: var(--space) var(--space-and-half) 0 var(--space-and-half);
    }

    .new-post__footer {
        align-self: unset;
        gap: var(--space);
        border-top: 1px solid var(--new-input-background-color);
        justify-content: space-between;
        width: 100%;
        padding: 12px;
    }

    .input-field-multiline.new-post__form__field {
        padding: 0 var(--space-and-half);
    }

    .new-post__header__button {
        margin-right: 0;
    }

    .new-post__header__buttons {
        gap: var(--space);
        padding: 12px;
        width: 100%;
        border-top: 1px solid var(--new-input-background-color);
        background: var(--white-color);
    }

    .new-post__header__buttons .button.small {
        font-size: 16px;
        padding: var(--space-half-quarter) var(--space-x3);
        line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));
        width: 50%;
    }

    .new-post__form__submit {
        margin-left: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/posts/components/create-post-modal/CreatePostModalComponent.styles.css"],"names":[],"mappings":";AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;AAC7B;AACA;IACI,UAAU;AACd;AACA;IACI,oDAAoD;IACpD,8BAA8B;AAClC;AACA;IACI,0BAA0B;IAC1B,2CAA2C;AAC/C;AACA;IACI,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,8BAA8B;AAClC;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,wBAAwB;;AAE5B;CACC;IACG,kDAAkD;AACtD;;AAEA;CACC,YAAY;IACT,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,kDAAkD;AACtD;;AAEA;CACC,kDAAkD;CAClD,8CAA8C;AAC/C;;AAEA;CACC,iDAAiD;CACjD,kCAAkC;IAC/B,UAAU;AACd;;AAEA;CACC,SAAS;CACT,SAAS;CACT,kBAAkB;IACf,oCAAoC;IACpC,kCAAkC;IAClC,+BAA+B;IAC/B,oEAAoE;IACpE,qCAAqC;AACzC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;AACf;AACA;IACI,YAAY;AAChB;AACA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,aAAa;AACjB;AACA;IACI,yDAAkE;IAClE,kBAAkB;IAClB,4BAA4B;IAC5B,sBAAsB;IACtB,sBAAsB;IACtB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;AACZ;AACA;IACI,6BAA6B;IAC7B,0BAA0B;AAC9B;AACA;IACI,kBAAkB;;;;IAIlB,aAAa;IACb,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,kBAAkB;IAClB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,gCAAgC;AACpC;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,SAAS;IACT,iCAAiC;AACrC;AACA;IACI,SAAS;AACb;AACA;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;AAC3B;AACA;IACI,oBAAoB;IACpB,yBAAyB;AAC7B;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,+BAA+B;IAC/B,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,gCAAgC;IAChC,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,gCAAgC;IAChC,yDAAyD,CAAC,SAAS;IACnE,4EAA4E,CAAC,SAAS;IACtF,wBAAwB;IACxB,qCAAqC;IACrC,YAAY;IACZ,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,0BAA0B;IAC1B,cAAc;IACd,iBAAiB;AACrB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;;AAGA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,YAAY;IACZ,iCAAiC;IACjC,wDAAwD;;AAE5D;;AAEA;IACI,yBAAyB;IACzB,oCAAoC;IACpC,oEAAoE;AACxE;;AAEA;IACI,oCAAoC;IACpC,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oCAAoC;IACpC,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,6BAA6B;IAC7B,wBAAwB;IACxB,mBAAmB;IACnB,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,sDAAsD;AAC1D;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;AACb;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI;QACI,SAAS;IACb;IACA;QACI,aAAa;IACjB;AACJ;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,SAAS;QACT,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,iBAAiB;IACrB;;IAEA;QACI,0DAA0D;QAC1D,4BAA4B;IAChC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,iBAAiB;QACjB,2BAA2B;IAC/B;;IAEA;QACI,+BAA+B;QAC/B,aAAa;IACjB;;IAEA;QACI,iCAAiC;QACjC,aAAa;IACjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,mBAAmB;QACnB,iBAAiB;QACjB,kBAAkB;QAClB,SAAS;QACT,WAAW;IACf;;IAEA;QACI,mEAAmE;IACvE;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;QACjB,uDAAuD;QACvD,8BAA8B;QAC9B,WAAW;QACX,aAAa;IACjB;;IAEA;QACI,gCAAgC;IACpC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,aAAa;QACb,WAAW;QACX,uDAAuD;QACvD,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,kDAAkD;QAClD,4EAA4E;QAC5E,UAAU;IACd;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["\n.new-post-modal .modal2__container {\n    width: 780px;\n}\n.new-post__header {\n    display: flex;\n    align-items: center;        \n    background: var(--white-color);\n    align-self: flex-start;\n    padding-top: var(--space);\n}\n.new-post__header .MuiList-padding, .new-post__header .MuiListItem-gutters{\n    padding: 0;\n}\n.new-post__header span.icon-chevron-down {\n    font-size: calc(var(--space) + var(--space-quarter));\n    margin-left: var(--space-half);\n}\np.new-post__header__title {\n    margin-right: var(--space);\n    color: var(--primary-dark-color) !important;\n}\n.new-post__header__button {\n    margin-right: var(--space);\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n}\n.new-post__header__button.baloa-names{\n    color: var(--basic-gray-color);\n}\n.new-post__content {\n    overflow-y: scroll;\n    max-height: 550px;\n    position: relative;\n    /* height: 300px; */\n    min-height: 0px;\n    margin-top: var(--space);\n\n}\n .new-post__content__progress{\n    margin: var(--space-half-quarter) 0 var(--space) 0;\n}\n\n.new-post__content__progress progress.new-post__content__progress__element {\n\tdisplay:flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    height: calc( var(--space) + var(--space-eighth) );\n}\n\n.new-post__content__progress progress.new-post__content__progress__element::-webkit-progress-bar {\n\theight: calc( var(--space) + var(--space-eighth) );\n\tbackground-color: var(--body-background-color);\n}\n\n.new-post__content__progress progress.new-post__content__progress__element::-webkit-progress-value {\n\theight:calc( var(--space) + var(--space-eighth) );\n\tbackground: var(--new-green-color);   \n    opacity: 1;\n}\n\n.new-post__content__progress__element:after {\n\tmargin: 0;\n\tpadding:0;\n\tposition: absolute;\n    font-size: var(--space-half-quarter);\n    font-family: var(--secondary-font);\n    font-weight: var(--font-medium);\n    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );\n    color: var(--primary-very-dark-color);\n}\n\n.new-post__content__media {\n    position: relative;\n    height: 400px;\n    width: 100%;\n}\n.new-post__content__media img {\n    height: 100%;\n}\n.new-post__content__media__video-control {\n    width: 100%;\n    height: 250px;\n    position: absolute;\n    top: 0;\n    left: 0;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n.new-post__content__media__video {\n    width: 100%;\n    height: 250px;\n}\n.new-post__content__media__video-control__icon {\n    background-image: url(\"../../../../assets/icons/play-control.png\");\n    position: absolute;\n    background-repeat: no-repeat;\n    width: var(--space-x3);\n    height:var(--space-x3);\n    background-size: contain;\n}\n.new-post__content__media__control-mute {\n    position: absolute;\n    right: 25%;\n    top: 50%;\n}\n.new-post__content__media__control-mute__icon {\n    color: var(--new-green-color);\n    font-size: var(--space-x2);\n}\n.new-post__content__result {\n    position: relative;\n\n\n\n    height: 400px;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n}\n.new-post__content__result__container {\n    position: relative;\n    height: 100%;\n}\n.new-post__content__result__container__remove {\n    position: absolute;\n    right: var(--space);\n    top: var(--space);\n}\n\n.new-post__content__result__container__remove__revert {\n    position: absolute;\n    right: var(--space);\n    top: var(--space);\n    z-index: 999;\n}\n\n.new-post__content__result img {\n    height: 100%;\n}\n\n.new-post__form {\n    background: var(--white-color);\n    width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    padding: 0 var(--space-and-half);\n}\n.new-post__form input {\n    width: 100%;\n}\n.new-post__form__form {\n    display: flex;\n    flex-direction: column;\n}\n.input-field.new-post__form__field {\n    margin: 0;\n    margin-top: var(--space-and-half);\n}\n.new-post__form__field input {\n    margin: 0;\n}\n.new-post__form__group {\n    display: flex;\n    justify-content: space-between;\n    padding: var(--space) 0;\n}\n.new-post__form__submit {\n    align-self: flex-end;\n    margin-left: var(--space);\n}\n.MuiAvatar-root.new-post__list-item__avatar{\n    width: 40px;\n    height: 40px;\n}\n\n.new-post__list-item__text .MuiTypography-body1{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-medium);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    color: var(--primary-dark-color);\n    padding-left: var(--space-half);\n}\n\n.new-post__list-item.icon-ball{\n    font-size: 30px;\n    font-weight: var(--font-bold);\n    border-radius: 50%;\n    padding: 5px;\n    height: 40px;\n    color: var(--white-color);\n}\n\n.new-post__form__field .input-field-multiline-input{\n    font-family: var(--secondary-font);\n    font-style: normal;\n    font-weight: var(--font-regular);\n    font-size: calc(var(--space) + var(--space-eighth) + 1px);/* 19px */\n    line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));/* 22px */\n    letter-spacing: 0.0025em;\n    color: var(--primary-very-dark-color);\n    border: none;\n    padding: 0;\n    background-color: transparent;\n}\n\n.new-post__form__field .input-field-multiline-input:focus { \n    outline: none; \n}\n\n.new-post__header__button .icon-image-70 {\n    font-size: var(--space-x2);\n    color: #64B5F6;\n    margin-right: 4px;\n}\n.new-post__header__button .icon2-video-offer {\n    font-size: var(--space-x2);\n    color: #F77B73;\n    margin-right: 4px;\n}\n.new-post__header__button .icon-field {\n    font-size: var(--space-x2);\n    color: #6ECB96;\n    margin-right: 4px;\n}\n.new-post__header__buttons{\n    display: flex;\n    align-items: center;\n}\n\n.create-post-modal__show-formation {\n    height: 42vh;\n}\n\n\n.create-post-modal__aspect-ratio {\n    position: absolute;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    width: 160px;\n    background: rgba(42, 48, 42, 0.6);\n    padding: calc( var(--space-half) - var(--space-eighth) );\n    \n}\n\n.create-post-modal__aspect-ratio .baloa-table-column {\n    color: var(--white-color);\n    font-size: var(--space-half-quarter);\n    line-height: calc( var(--space-half-quarter) + var(--space-eighth) );\n}\n\n.create-post-modal__aspect-ratio > div:not(:first-of-type) { \n    border: 1px solid var(--white-color);\n    border-radius: var(--space-eighth);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    font-size: var(--space-half-quarter);\n    text-align: center;    \n}\n\n.create-post-modal__aspect-ratio__horizontal {\n    width: var(--space-x2 );\n    height: var(--space-and-half );\n    background: #D9D9D9;\n    color: var(--primary-very-dark-color);\n}\n\n.create-post-modal__aspect-ratio__square {\n    width: var(--space-and-half );\n    height: var(--space-and-half );\n    background: #D9D9D9;\n    color: var(--primary-very-dark-color);    \n}\n\n.create-post-modal__aspect-ratio__vertical {\n    width: var(--space-and-half );\n    height: var(--space-x2 );\n    background: #D9D9D9;\n    color: var(--primary-very-dark-color); \n}\n\n.create-post-modal__aspect-ratio .active {\n    background: transparent;\n    color: var( --white-color );\n}\n\n#lock-menu .MuiMenu-paper{\n    max-height: calc(100vh - 96px);\n}\n\n.new-post__content__media__video-add-options {\n    border: 1px solid var(--new-gray-background-color);\n    border-radius: 8px;\n}\n\n.new-post__content__media__video-add-options__option {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 14px;\n    border-top: 1px solid var(--new-gray-background-color);\n}\n\n.new-post__content__media__video-add-options__option:first-child {\n    border-top: none;\n}\n\n.new-post__content__media__video-add-options__option-text {\n    display: flex;\n    align-items: center;\n    justify-content: flex-start;\n    gap: 10px;\n}\n\n.new-post__content__media__video-add-options__option-text .baloa-names {\n    color: var(--primary-very-dark-color);\n}\n\n.new-post__content__media__video-add-options__option-text .hubicon-video_library1::before {\n    font-size: 20px;\n    color: #0D6EFD;\n}\n\n.new-post__content__media__video-add-options__option-text .hubicon-video_camera_front1::before {\n    font-size: 20px;\n    color: #FD9843;\n}\n\n.new-post__form__form .input-field-multiline {\n    margin-top: var(--space-and-half);\n    margin-bottom: 0;\n}\n\n.new-post__footer {\n    display: flex;\n    align-items: center;        \n    background: var(--white-color);\n    align-self: flex-start;\n    padding-top: var(--space);\n}\n\n@media screen and ( max-width: 375px ) {\n\n    .input-field-multiline.new-post__form__field{\n        margin: 0;\n    }\n    .new-post__content__media {\n        height: 250px;\n    }\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .new-post-modal .modal2__container {\n        margin: 0;\n        width: 100%;\n        border-radius: 0;\n        height: 100%;\n        max-height: unset;\n    }\n\n    .new-post-modal .modal2__header {\n        border-bottom: 1px solid var(--new-input-background-color);\n        padding-bottom: var(--space);\n    }\n\n    .new-post-modal .modal2__content { \n        height: 100%;\n    }\n\n    .new-post__form {\n        padding: 0;\n    }\n\n    .new-post__content {\n        max-height: unset;\n        height: calc(100vh - 300px);\n    }\n\n    .new-post__content__media__video {\n        max-height: calc(100vh - 520px);\n        height: unset;\n    }\n\n    .new-post__content__media {\n        /* height: calc(100vh - 480px); */\n        height: unset;\n    }\n\n    .new-post__content__media__video-add-options__option {\n        padding: 14px 10px;\n    }\n\n    .new-post__content__media__video-add-options {\n        margin: 12px;\n    }\n\n    .new-post__form__group {\n        flex-direction: column;\n        align-items: center;\n        padding-bottom: 0;\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .new-post__header {\n        padding: var(--space) var(--space-and-half) 0 var(--space-and-half);\n    }\n\n    .new-post__footer {\n        align-self: unset;\n        gap: var(--space);\n        border-top: 1px solid var(--new-input-background-color);\n        justify-content: space-between;\n        width: 100%;\n        padding: 12px;\n    }\n\n    .input-field-multiline.new-post__form__field {\n        padding: 0 var(--space-and-half);\n    }\n\n    .new-post__header__button {\n        margin-right: 0;\n    }\n\n    .new-post__header__buttons {\n        gap: var(--space);\n        padding: 12px;\n        width: 100%;\n        border-top: 1px solid var(--new-input-background-color);\n        background: var(--white-color);\n    }\n\n    .new-post__header__buttons .button.small {\n        font-size: 16px;\n        padding: var(--space-half-quarter) var(--space-x3);\n        line-height: calc(var(--space) + var(--space-quarter) + var(--space-eighth));\n        width: 50%;\n    }\n\n    .new-post__form__submit {\n        margin-left: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
